import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["homeRoute", "showHomeIcon", "label", "className", "appNavigator", "appNavigatorClassName", "appMenuItems", "navItems", "actionBarItems", "onToggleAppMenu"];
import React, { useState, useRef, forwardRef, useCallback, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/fp/debounce';
import isEmpty from 'lodash/fp/isEmpty';
import classname from 'classnames';
import { AppMenu } from './AppMenu';
import { ApplicationActionBar } from './ApplicationActionBar';
import { MobileSubmoduleNavigation } from './MobileSubmoduleNavigation';
import useResizeObserver from '../../hooks/useResizeObserver';
import NavItems from './NavItems';
import modulePropTypes from './modulePropTypes';
import { MobileAppMenu } from './MobileAppMenu';
var SCREEN_SM = 768; // @screen-sm: 768px;

export var ApplicationHeader = /*#__PURE__*/forwardRef(function (props, ref) {
  var homeRoute = props.homeRoute,
    showHomeIcon = props.showHomeIcon,
    label = props.label,
    className = props.className,
    appNavigator = props.appNavigator,
    appNavigatorClassName = props.appNavigatorClassName,
    appMenuItems = props.appMenuItems,
    navItems = props.navItems,
    actionBarItems = props.actionBarItems,
    onToggleAppMenu = props.onToggleAppMenu,
    remainigProps = _objectWithoutProperties(props, _excluded);
  var actionBarRef = useRef();
  var _useResizeObserver = useResizeObserver(),
    _useResizeObserver2 = _slicedToArray(_useResizeObserver, 2),
    navRef = _useResizeObserver2[0],
    contentRect = _useResizeObserver2[1].contentRect;
  useImperativeHandle(ref, function () {
    return navRef;
  }, []);
  var getContentRect = useCallback(function (key) {
    return contentRect && Math.round(contentRect[key]);
  }, [contentRect]);
  var containerWidth = getContentRect('width') || 0;
  var isMobileWidth = containerWidth <= SCREEN_SM;
  var hasActionBarItems = !isEmpty(actionBarItems);
  var classNames = classname('ApplicationHeader', 'user-select-none', isMobileWidth && 'mobile', className && className);
  return /*#__PURE__*/React.createElement("nav", _extends({}, remainigProps, {
    className: classNames,
    ref: navRef
  }), isMobileWidth && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MobileAppMenu, {
    showHomeIcon: showHomeIcon,
    homeRoute: homeRoute,
    appMenuItems: appMenuItems,
    appNavigator: appNavigator,
    onToggleAppMenu: onToggleAppMenu
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex-1-1-0 display-flex gap-10"
  }, /*#__PURE__*/React.createElement(MobileSubmoduleNavigation, {
    className: "flex-1-1",
    label: label,
    navItems: navItems,
    actionBarItems: actionBarItems
  }), hasActionBarItems && /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(ApplicationActionBar, {
    className: "mobile",
    items: actionBarItems
  }))), !isMobileWidth && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "navbar-header"
  }, /*#__PURE__*/React.createElement("span", {
    className: "navbar-brand ".concat(showHomeIcon ? 'home-icon' : '')
  }, homeRoute)), label && /*#__PURE__*/React.createElement(AppMenu, {
    label: label,
    key: "AppMenu",
    appMenuItems: appMenuItems,
    appNavigator: appNavigator,
    appNavigatorClassName: appNavigatorClassName,
    onToggleAppMenu: onToggleAppMenu
  }), isEmpty(navItems) && /*#__PURE__*/React.createElement("ul", {
    className: "SubmoduleNavigation nav"
  }), !isEmpty(navItems) && /*#__PURE__*/React.createElement(NavItems, {
    key: "NavItems",
    navItems: navItems,
    containerWidth: containerWidth,
    actionBarItems: actionBarItems
  }), /*#__PURE__*/React.createElement(ApplicationActionBar, {
    nodeRef: actionBarRef,
    items: actionBarItems
  })));
});
var Divider = function Divider() {
  return /*#__PURE__*/React.createElement("div", {
    className: "divider display-flex align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "width-3 height-20 bg-lighter"
  }));
};
export default ApplicationHeader;
ApplicationHeader.defaultProps = {
  homeRoute: '',
  showHomeIcon: true,
  actionBarItems: [],
  onToggleAppMenu: function onToggleAppMenu() {}
};
ApplicationHeader.propTypes = {
  label: PropTypes.node,
  className: PropTypes.string,
  homeRoute: PropTypes.node.isRequired,
  showHomeIcon: PropTypes.bool,
  appMenuItems: PropTypes.arrayOf(modulePropTypes),
  appNavigator: PropTypes.node,
  appNavigatorClassName: PropTypes.string,
  navItems: PropTypes.arrayOf(modulePropTypes),
  actionBarItems: PropTypes.arrayOf(PropTypes.node),
  onToggleAppMenu: PropTypes.func
};